"use client";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { system } from "@/lib/dto/system/system";
import { ImgLogo } from "@/lib/images";
import { Menu } from "lucide-react";
import Image from "next/image";
import Link from "next/link";
import React from "react";
import { NavSheet } from "./nav-sheet";

export default function MobileNav() {
  const [open, setOpen] = React.useState(false);
  return (
    <div className="flex items-center justify-between p-4 lg:hidden bg-white/80 backdrop-blur-md border-b border-gray-200/50 sticky top-0 z-50">
      {/* Logo */}
      <div className="flex items-center space-x-2">
        <Link href="/">
          <Image
            src={ImgLogo}
            alt={system.company_name}
            width={300}
            height={165}
            className="w-28 md:w-30 h-auto object-contain"
          />
        </Link>
      </div>
      <div className="flex items-center gap-x-3">
        <div className="hidden sm:block">
          <Link href="/case-studies">
            <Button variant="outline" className="shadow-none rounded-lg">
              Our Work
            </Button>
          </Link>
        </div>

        {/* Our Work Button for Mobile */}
        <div className="sm:hidden">
          <Link href="/case-studies">
            <Button variant="outline" className="shadow-none rounded-lg text-sm px-3 py-2">
              Our Work
            </Button>
          </Link>
        </div>

        {/* Mobile Menu Trigger */}
        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger asChild>
            <Button
              variant="outline"
              size="icon"
              className="lg:hidden hover:bg-gray-100 rounded-lg"
            >
              <Menu className="h-6 w-6 text-gray-700" />
              <span className="sr-only">Toggle navigation menu</span>
            </Button>
          </SheetTrigger>
          <SheetContent
            side="right"
            className="w-[300px] sm:w-[350px] z-100 p-0 bg-white/95 backdrop-blur-xl border-l border-gray-200/50 overflow-hidden"
          >
            <SheetTitle></SheetTitle>
            <NavSheet onClose={() => setOpen(false)} />
          </SheetContent>
        </Sheet>
      </div>
    </div>
  );
}
